// extracted by mini-css-extract-plugin
export var chevron = "_my-3";
export var chevronRotated = "_my-4";
export var image = "_my-1";
export var imageContainer = "_my-0";
export var shippingAddress = "_my-2";